import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function AdminUnlicensed() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4">
      <div className="glass-strong max-w-md w-full p-10 text-center rounded-sm">
        <ShieldAlert className="mx-auto text-[#E63946]" size={48} />
        <h1 className="font-display text-3xl text-white mt-4">Panel no licenciado</h1>
        <p className="text-white/60 text-sm mt-3">
          El acceso al panel de administración está desactivado. Contacta al administrador de plataforma.
        </p>
        <Link to="/admin/login" className="btn-outline mt-6 inline-block text-sm">
          Volver al login
        </Link>
      </div>
    </div>
  );
}
